module.exports = __webpack_public_path__ + "static/media/add.a7e1c302.svg";